import React from "react";
import { ProtectedRoute } from ".";
import PathConstants from "./pathConstants";

const Home = React.lazy(() => import("../pages/core/Home"));

// Variant
const VariantEditor = React.lazy(
  () => import("../pages/variant/VariantEditor")
);
const VariantPlayer = React.lazy(
  () => import("../pages/variant/VariantPlayer")
);

export const noNavRoutes = [
  {
    path: PathConstants.VARIANT_PLAYER,
    element: (
      <ProtectedRoute>
        <VariantPlayer />
      </ProtectedRoute>
    ),
  },
];

export const lightNavRoutes = [
  {
    path: PathConstants.VARIANT_EDITOR,
    element: (
      <ProtectedRoute builderRequired={true}>
        <VariantEditor />
      </ProtectedRoute>
    ),
  },
];

export const hideToolsRoutes = [
  {
    path: PathConstants.HOME,
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
  },
];
